module.exports = __webpack_public_path__ + "static/media/s-tokariev.27cd0887.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/s-tokariev.jpg
// module id = 81
// module chunks = 0